import React from 'react';
import Grid from 'atoms/Layout/Grid/Grid';
import SectionLayout from 'atoms/Layout/Section/SectionLayout';
import Stack from 'atoms/Layout/Stack/Stack';
import BehindResultsFeed from 'organisms/Homepage/BehindResultsFeed/BehindResultsFeed';
import BehindResultsTextBlock from 'organisms/Homepage/BehindResultsTextBlock/BehindResultsTextBlock';

const BehindResults = (): JSX.Element => (
  <SectionLayout
    maxWidth='width-3xl'
    padding={['spacing-7xl', 'spacing-none']}
    paddingSm={['spacing-4xl', 'spacing-none']}
  >
    <Grid
      padding={['spacing-none', 'spacing-4xl']}
      paddingSm={['spacing-none', 'spacing-xl']}
      gap='spacing-7xl'
      gapXl='spacing-3xl'
    >
      <Stack
        justify='flex-start'
        align='flex-start'
        columns={5}
        columnsXl={12}
      >
        <BehindResultsTextBlock />
      </Stack>
      <Stack
        columns={7}
        columnsXl={12}
      >
        <BehindResultsFeed />
      </Stack>
    </Grid>
  </SectionLayout>
);

export default BehindResults;
